/** Shared DPDP notice version — bump when privacy notice text changes materially. */
export const PRIVACY_NOTICE_VERSION = '2026-10-02';

export const ESSENTIAL_PURPOSES = [
  'account_auth',
  'ride_matching',
  'safety_communications',
  'fraud_prevention',
];
